import { Component, Input, NgZone, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";

export enum DialogSize {
  Small,
  Normal,
  Large
}

@Component({
  selector: 'powerbi-modal',
  templateUrl: './powerbi-modal.component.html',
  styleUrl: './powerbi-modal.component.css',
  standalone: false
})
export class PowerbiModalComponent {
  public visible: boolean = false;
  public dialogSize = DialogSize;

  @Input() public dialogId: string = '';
  @Input() public title: string = '';

  @Output() public acceptEvent = new EventEmitter<void>();

  constructor(private zone: NgZone, private changeDetector: ChangeDetectorRef) {

  }
  public open(): void {
    this.zone.run(() => {
      this.visible = true;
      this.changeDetector.detectChanges();
    });
  }

  public close(event: Event): void {
    if (event) event.stopPropagation();
    this.zone.run(() => {
      this.visible = false;
      this.changeDetector.detectChanges();
    });
  }

  public fastEventKilling(event: Event) {
    event.stopPropagation();
    var evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 1, 1, 1, 1, 1, false, false, true, false, 0, null);
    document.querySelector("body").dispatchEvent(evt);
  }
}